/* FG Edwards: "how do I get it?" on product pages and in the cart drawer (docs/pdp/01-abandoned-checkouts.md).
   - Product page panel [data-fg-fulfil]: pickup at both stores (with "prêt aujourd'hui" when true), local delivery,
     Canada-wide shipping, and a postal-code answer before checkout.
   - Cart drawer [data-fg-ship-est]: the same answer for the whole cart; outside the local zone it shows the real
     cheapest carrier rate from Shopify's cart shipping-rate endpoint, so nobody needs checkout to learn the price.
   Zone data comes from /pages/livraison (the delivery page's own settings), as on the homepage.
   Remembered on this device: the first three characters, the result and the route days (localStorage, shared with
   the homepage's "fgh_route"); the full code only for this browsing session (sessionStorage), for rate estimates. */
(function () {
  'use strict';
  if (window.__fgFulfil) return;
  window.__fgFulfil = 1;

  var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var NB = ' ';
  var ZONES_URL = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/').replace(/\/?$/, '/') + 'pages/livraison';

  function send(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
  }

  /* ---------- Zone data and route days (same rules as the homepage) ---------- */
  var zonesPromise = null;
  function loadZones() {
    if (zonesPromise) return zonesPromise;
    zonesPromise = fetch(ZONES_URL, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        function read(id) { var el = doc.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
        var data = { fsas: read('fge-eligible-fsas'), zones: read('fge-zone-map'), days: read('fge-delivery-days') };
        if (!Array.isArray(data.fsas) || !data.fsas.length) throw new Error('data');
        return data;
      });
    zonesPromise.catch(function () { zonesPromise = null; });
    return zonesPromise;
  }
  function routeDays(code, data) {
    if (!data.zones || !data.days) return [];
    var best = 0, zones = [];
    Object.keys(data.zones).forEach(function (prefix) {
      if (code.indexOf(prefix) !== 0) return;
      var z = data.zones[prefix];
      z = Array.isArray(z) ? z : [z];
      if (prefix.length > best) { best = prefix.length; zones = z.slice(); }
      else if (prefix.length === best) z.forEach(function (x) { if (zones.indexOf(x) < 0) zones.push(x); });
    });
    var days = [];
    zones.forEach(function (z) { var d = data.days[z]; if (typeof d === 'number' && days.indexOf(d) < 0) days.push(d); });
    return days.sort();
  }
  function nextDelivery(days) {
    var cal = window.FGStoreCalendar;
    if (!cal || !days || !days.length) return null;
    var today = cal.today();
    for (var i = 1; i <= 35; i++) {
      var date = cal.addDays(today, i);
      if (days.indexOf(cal.weekday(date)) > -1 && !cal.closure(date)) return { date: date, offset: i };
    }
    return null;
  }
  function fmtDate(iso, opts) {
    var p = iso.split('-');
    return new Intl.DateTimeFormat(en ? 'en-CA' : 'fr-CA', opts).format(new Date(+p[0], +p[1] - 1, +p[2]));
  }
  /* "jeudi 9 octobre (commandez d'ici mercredi minuit)" */
  function deliveryLine(days) {
    var next = nextDelivery(days);
    if (!next) return '';
    var cal = window.FGStoreCalendar;
    var when = fmtDate(next.date, { weekday: 'long', day: 'numeric', month: 'long' });
    var cutoff = next.offset === 1
      ? (en ? 'order by midnight tonight' : 'commandez d’ici minuit ce soir')
      : (en ? 'order by midnight ' : 'commandez d’ici ') + fmtDate(cal.addDays(next.date, -1), { weekday: 'long' }) + (en ? '' : ' minuit');
    return { when: when, cutoff: cutoff };
  }

  /* ---------- Postal codes ---------- */
  function clean(v) { return (v || '').replace(/\s/g, '').toUpperCase(); }
  function pretty(code) { return code.length > 3 ? code.slice(0, 3) + ' ' + code.slice(3) : code; }
  function valid(code) { return /^[ABCEGHJKLMNPRSTVXY]\d[A-Z]\d[A-Z]\d$/.test(code); }
  var PROVINCES = { A: 'Newfoundland and Labrador', B: 'Nova Scotia', C: 'Prince Edward Island', E: 'New Brunswick', G: 'Quebec', H: 'Quebec', J: 'Quebec', K: 'Ontario', L: 'Ontario', M: 'Ontario', N: 'Ontario', P: 'Ontario', R: 'Manitoba', S: 'Saskatchewan', T: 'Alberta', V: 'British Columbia', X: 'Northwest Territories', Y: 'Yukon' };
  function formatInput(input) {
    input.addEventListener('input', function () {
      var v = clean(input.value).slice(0, 6);
      input.value = pretty(v);
    });
  }

  var KEY = 'fg_postal', ROUTE_KEY = 'fgh_route', SKEY = 'fg_postal_full';
  function remember(code, result) {
    var fsa = code.slice(0, 3);
    try { localStorage.setItem(KEY, JSON.stringify({ fsa: fsa, ok: result.ok, days: result.days || [], t: Date.now() })); } catch (e) {}
    if (result.ok && result.days && result.days.length) {
      try { localStorage.setItem(ROUTE_KEY, JSON.stringify({ fsa: fsa, days: result.days, t: Date.now() })); } catch (e) {}
    }
    try { sessionStorage.setItem(SKEY, code); } catch (e) {}
  }
  function recall() {
    var r = null, full = null;
    try { r = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!r) { try { var h = JSON.parse(localStorage.getItem(ROUTE_KEY) || 'null'); if (h && h.fsa) r = { fsa: h.fsa, ok: true, days: h.days || [] }; } catch (e) {} }
    try { full = sessionStorage.getItem(SKEY); } catch (e) {}
    if (r && full && full.indexOf(r.fsa) !== 0) full = null;
    return r ? { fsa: r.fsa, ok: !!r.ok, days: r.days || [], full: full } : null;
  }
  function forget() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    try { sessionStorage.removeItem(SKEY); } catch (e) {}
  }
  function check(code) {
    return loadZones().then(function (data) {
      var ok = data.fsas.some(function (p) { return code.indexOf(p) === 0; });
      var res = { ok: ok, days: ok ? routeDays(code, data) : [] };
      remember(code, res);
      return res;
    });
  }

  /* ---------- Pickup: "prêt aujourd'hui" only when it is true right now ---------- */
  function storeNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
      var h = 0, m = 0;
      parts.forEach(function (p) { if (p.type === 'hour') h = +p.value; if (p.type === 'minute') m = +p.value; });
      return h * 60 + m;
    } catch (e) { var d = new Date(); return d.getHours() * 60 + d.getMinutes(); }
  }
  function readyToday() {
    var cal = window.FGStoreCalendar;
    if (!cal) return false;
    var t = cal.today(), mins = storeNow();
    return cal.weekday(t) !== 0 && !cal.closure(t) && mins >= 6 * 60 && mins < 15 * 60;
  }

  /* ---------- Money (follows the shop's money format) ---------- */
  function money(amount, format) {
    var n = Number(amount);
    if (isNaN(n)) return amount;
    var fixed = n.toFixed(2), whole = fixed.split('.')[0], cents = fixed.split('.')[1];
    var thousands = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var f = format || (en ? '${{amount}}' : '{{amount_with_comma_separator}} $');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return thousands(whole, '.') + ',' + cents;
      if (k === 'amount_no_decimals') return thousands(whole, ',');
      if (k === 'amount_no_decimals_with_comma_separator') return thousands(whole, '.');
      if (k === 'amount_with_space_separator') return thousands(whole, ' ') + ',' + cents;
      return thousands(whole, ',') + '.' + cents;
    });
  }

  /* ==================================================================== Product page panel */
  function initPanel(root) {
    if (root.__fgInit) return;
    root.__fgInit = 1;
    var form = root.querySelector('[data-fg-fulfil-form]');
    var input = root.querySelector('[data-fg-fulfil-input]');
    var out = root.querySelector('[data-fg-fulfil-result]');
    var ready = root.querySelector('[data-fg-fulfil-ready]');
    var shippable = root.getAttribute('data-shippable') === 'true';
    var noLocal = root.getAttribute('data-no-local') === 'true';
    var kg = parseFloat(root.getAttribute('data-kg') || '0');
    var inStock = root.getAttribute('data-available') === 'true';

    if (ready && inStock && readyToday()) ready.hidden = false;
    if (!form || !input || !out) return;
    formatInput(input);
    input.addEventListener('focus', function () { loadZones().catch(function () {}); }, { once: true });

    function show(state, html, withChange) {
      out.className = 'fg-fulfil__result is-' + state;
      out.innerHTML = html + (withChange ? ' <button type="button" class="fg-fulfil__change" data-fg-fulfil-change>' + (en ? 'Change' : 'Changer') + '</button>' : '');
      out.hidden = false;
      form.hidden = !!withChange;
      root.setAttribute('data-state', state);
    }
    function answer(fsa, res) {
      var box = root.closest('.fg-fastbuy');
      if (box) box.classList.toggle('fg-out-of-zone', !res.ok);
      /* Short answers: once the code is known the panel shows pickup plus this one line (assets/fg-fulfil.css). */
      if (res.ok && !noLocal) {
        var d = root.getAttribute('data-no-date') === 'true' ? null : deliveryLine(res.days);
        return show('ok', d
          ? (en ? '<b>Delivered ' + d.when + '</b> (' + fsa + '), free from $95. ' + d.cutoff.charAt(0).toUpperCase() + d.cutoff.slice(1) + '.'
                : '<b>Livré ' + d.when + '</b> (' + fsa + '), gratuit dès 95' + NB + '$. ' + d.cutoff.charAt(0).toUpperCase() + d.cutoff.slice(1) + '.')
          : (en ? '<b>We deliver to your area (' + fsa + ')</b>, free from $95, Tuesday to Thursday.'
                : '<b>On livre dans votre secteur (' + fsa + ')</b>, gratuit dès 95' + NB + '$, du mardi au jeudi.'), true);
      }
      if (res.ok && noLocal) {
        return show('pickup', en ? '<b>Pickup only</b> for this item: Bedford or West Brome.' : '<b>En ramassage seulement</b> pour ce produit' + NB + ': Bedford ou West Brome.', true);
      }
      if (shippable) {
        var heavy = kg >= 15 ? (en ? 'Heavy item (' + Math.round(kg) + ' kg): the' : 'Article lourd (' + Math.round(kg) + ' kg)' + NB + ': le') : (en ? 'The' : 'Le');
        return show('ship', en
          ? '<b>Shipped by carrier</b> to your area (' + fsa + '), outside our local zone. ' + heavy + ' exact price shows in the cart, before you pay.'
          : '<b>Expédié par transporteur</b> dans votre secteur (' + fsa + '), hors de notre zone locale. ' + heavy + ' prix exact s’affiche dans le panier, avant de payer.', true);
      }
      show('pickup', en ? '<b>Pickup only</b> for your area (' + fsa + '), outside our delivery zone.' : '<b>En ramassage seulement</b> pour votre secteur (' + fsa + '), hors de notre zone de livraison.', true);
    }

    var known = recall();
    if (known) answer(known.fsa, known);

    out.addEventListener('click', function (e) {
      if (!e.target.closest('[data-fg-fulfil-change]')) return;
      forget();
      var box = root.closest('.fg-fastbuy');
      if (box) box.classList.remove('fg-out-of-zone');
      out.hidden = true;
      form.hidden = false;
      root.removeAttribute('data-state');
      input.value = '';
      input.focus();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = clean(input.value);
      if (!valid(code)) { show('error', en ? 'Enter a full postal code, for example J0E 2P0.' : 'Entrez un code postal complet, par exemple J0E 2P0.', false); input.focus(); return; }
      form.setAttribute('aria-busy', 'true');
      check(code).then(function (res) {
        form.removeAttribute('aria-busy');
        answer(code.slice(0, 3), res);
        send('fg_pdp_postal_check', { result: res.ok ? 'eligible' : 'outside', fsa: code.slice(0, 3), shippable: shippable, kg: kg });
      }).catch(function () {
        form.removeAttribute('aria-busy');
        show('error', en ? 'We can’t check right now. See the <a href="' + ZONES_URL + '">delivery page</a>.' : 'Vérification impossible pour le moment. Voir la <a href="' + ZONES_URL + '">page Livraison</a>.', false);
      });
    });
  }

  /* ==================================================================== Cart drawer estimate */
  var rateCache = {};
  function cartRates(code) {
    var q = 'shipping_address[zip]=' + encodeURIComponent(pretty(code)) + '&shipping_address[country]=Canada&shipping_address[province]=' + encodeURIComponent(PROVINCES[code[0]] || '');
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var key = code + '|' + cart.token + '|' + cart.total_price + '|' + cart.item_count;
      if (rateCache[key]) return rateCache[key];
      rateCache[key] = fetch('/cart/prepare_shipping_rates.json?' + q, { method: 'POST', credentials: 'same-origin' }).then(function () {
        var tries = 0;
        function poll() {
          return fetch('/cart/async_shipping_rates.json?' + q, { credentials: 'same-origin' }).then(function (r) {
            if (r.status === 200) return r.json().then(function (j) { if (j && j.shipping_rates) return j.shipping_rates; throw new Error('empty'); });
            if (++tries > 14) throw new Error('timeout');
            return new Promise(function (res) { setTimeout(res, 700); }).then(poll);
          });
        }
        return poll();
      });
      rateCache[key].catch(function () { delete rateCache[key]; });
      return rateCache[key];
    });
  }

  function initEstimate(root) {
    if (root.__fgInit) return;
    root.__fgInit = 1;
    var form = root.querySelector('[data-fg-ship-est-form]');
    var input = root.querySelector('[data-fg-ship-est-input]');
    var out = root.querySelector('[data-fg-ship-est-result]');
    var open = root.querySelector('[data-fg-ship-est-open]');
    var fmt = root.getAttribute('data-money-format');
    var subtotal = parseInt(root.getAttribute('data-subtotal') || '0', 10);
    var noLocal = root.getAttribute('data-no-local') === 'true';
    /* The drawer's single fulfilment block (docs/cart/02-build-k1-k2.md): once the postal code has an answer,
       that answer replaces the general statement instead of sitting under it. */
    var one = root.getAttribute('data-one') === 'true';
    var lead = root.querySelector('[data-fg-cartget-lead]');
    var remaining = parseInt(root.getAttribute('data-remaining') || '0', 10);
    if (!form || !input || !out) return;
    formatInput(input);

    function show(state, html) {
      if (lead) lead.hidden = true;
      out.className = 'fg-ship-est__result is-' + state;
      out.innerHTML = html + ' <button type="button" class="fg-ship-est__change" data-fg-ship-est-change>' + (en ? 'Change' : 'Changer') + '</button>';
      out.hidden = false;
      form.hidden = true;
      if (open) open.hidden = true;
    }
    function rates(code) {
      show('wait', en ? 'Getting shipping rates to ' + pretty(code) + '…' : 'Calcul des frais de transport vers ' + pretty(code) + '…');
      cartRates(code).then(function (list) {
        if (!list || !list.length) throw new Error('none');
        var best = list.slice().sort(function (a, b) { return Number(a.price) - Number(b.price); })[0];
        show('ship', en
          ? 'Shipping to <b>' + pretty(code) + '</b>: from <b>' + money(best.price, fmt) + '</b> (' + best.name + ') for this cart. The exact rate is confirmed at checkout.'
          : 'Expédition vers <b>' + pretty(code) + '</b>' + NB + ': à partir de <b>' + money(best.price, fmt) + '</b> (' + best.name + ') pour ce panier. Le tarif exact est confirmé à la caisse.');
        send('fg_cart_ship_estimate', { fsa: code.slice(0, 3), result: 'rate', price: Number(best.price) });
      }).catch(function () {
        show('ship', en ? 'Shipping to ' + pretty(code) + ' will be calculated at checkout.' : 'Les frais d’expédition vers ' + pretty(code) + ' seront calculés à la caisse.');
      });
    }
    /* The free-local-delivery progress bar means nothing outside the zone: hide it there. */
    function localBar(on) {
      var foot = root.closest('.cart-drawer__footer, .drawer__footer, form, body');
      var bar = foot && foot.querySelector('.free-shipping-bar');
      if (bar) bar.hidden = !on;
    }
    function answer(code, res, fsaOnly) {
      var fsa = (code || '').slice(0, 3);
      localBar(!!res.ok);
      if (res.ok && !noLocal) {
        var d = root.getAttribute('data-no-date') === 'true' ? null : deliveryLine(res.days);
        var met = subtotal >= 9500;
        if (one) {
          var left = money(remaining / 100, fmt);
          return show('ok', en
            ? (d ? '<b>Delivered ' + d.when + '</b> (' + fsa + '), ' + d.cutoff + '. ' : '<b>We deliver to your area</b> (' + fsa + '), Tuesday to Thursday. ') + (met ? '<b>Free</b> for this order.' : 'Free from $95: <b>' + left + ' to go</b>.')
            : (d ? '<b>Livré ' + d.when + '</b> (' + fsa + '), ' + d.cutoff + '. ' : '<b>On livre dans votre secteur</b> (' + fsa + '), du mardi au jeudi. ') + (met ? '<b>Gratuit</b> pour cette commande.' : 'Gratuit dès 95' + NB + '$' + NB + ': <b>plus que ' + left + '</b>.'));
        }
        var txt = en
          ? '<b>We deliver to your area (' + fsa + ').</b> ' + (d ? 'Next delivery: <b>' + d.when + '</b>, ' + d.cutoff + '. ' : '') + (met ? 'Free for this order: ' : 'Free from $95: ') + 'choose local delivery at checkout.'
          : '<b>On livre dans votre secteur (' + fsa + ').</b> ' + (d ? 'Prochaine livraison' + NB + ': <b>' + d.when + '</b>, ' + d.cutoff + '. ' : '') + (met ? 'Gratuite pour cette commande' + NB + ': ' : 'Gratuite dès 95' + NB + '$' + NB + ': ') + 'choisissez la livraison locale à la caisse.';
        return show('ok', txt);
      }
      if (fsaOnly) {
        /* Only the first three characters are remembered across visits: ask again for a rate. */
        if (lead) lead.hidden = true;
        out.hidden = true; form.hidden = false; if (open) open.hidden = true;
        input.placeholder = fsa + ' …';
        return;
      }
      rates(code);
    }

    var known = recall();
    if (known) answer(known.full || known.fsa, known, !known.full && !known.ok);

    if (open) open.addEventListener('click', function () { open.hidden = true; form.hidden = false; input.focus(); loadZones().catch(function () {}); });
    out.addEventListener('click', function (e) {
      if (!e.target.closest('[data-fg-ship-est-change]')) return;
      forget();
      localBar(true);
      if (lead) lead.hidden = false;
      out.hidden = true; form.hidden = false; input.value = ''; input.focus();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = clean(input.value);
      if (!valid(code)) { out.className = 'fg-ship-est__result is-error'; out.hidden = false; out.textContent = en ? 'Enter a full postal code, for example J0E 2P0.' : 'Entrez un code postal complet, par exemple J0E 2P0.'; return; }
      check(code).then(function (res) { answer(code, res, false); }).catch(function () { rates(code); });
    });
  }

  /* The same postal-code memory and answers, for other pages (the listing's delivery line, assets/fg-collection.js). */
  window.FGFulfil = { readyToday: readyToday, recall: recall, forget: forget, check: check, valid: valid, clean: clean, deliveryLine: deliveryLine, formatInput: formatInput, send: send, zonesUrl: ZONES_URL };

  /* ---------- Wire up now, and again whenever the cart drawer re-renders ---------- */
  function scan(scope) {
    (scope || document).querySelectorAll('[data-fg-fulfil]').forEach(initPanel);
    (scope || document).querySelectorAll('[data-fg-ship-est]').forEach(initEstimate);
  }
  function start() {
    scan();
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; scan(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
